export const intellisuggestClickTracking = (element, data, signature) => {
  const href = element.currentTarget.href;
  const siteId = 'hn3c68'; // This is Gathr's unique ID
  var escapeFn = encodeURIComponent || escape;
  var api_url;
  if (document.images) {
    if ('https:' == location.protocol) {
      api_url = 'https://' + siteId + '.a.searchspring.io/api/';
    } else {
      api_url = 'http://' + siteId + '.a.searchspring.io/api/';
    }

    var imgTag = new Image();
    imgTag.src =
      api_url +
      'track/track.json?d=' +
      data +
      '&s=' +
      signature +
      '&u=' +
      escapeFn(href) +
      '&r=' +
      escapeFn(document.referrer);
  }

  return true;
};
